export default {
  CALL_SERVER: 1,
  SURVEY_POSTED: 2,
  SERVER_APP_CARD_PAYMENT: 3,
  SERVER_APP_CASH_PAYMENT: 4,
  GUEST_APP_CARD_PAYMENT: 5,
  KIOSK_TABLE_CHECK_IN: 6,
  GUEST_APP_CHECK_IN: 7,
  SERVER_APP_PRINTER: 8,
  NEW_ORDER: 9,
  PRINT_SERVER_PRINT: 18,
};
